import React from "react";
import { useLocation } from "react-router-dom";

//Scroll to the top of the page on navigation (or to the #hash target if there is one)
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) {
      //Wait for the page transition to render the target
      const timeout = window.setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 350);
      return () => window.clearTimeout(timeout);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    return undefined;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
